import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

/**
 * Updates the `timeAgo` field in an array of objects.
 * @param items Array of objects containing a `createdAt` field.
 */
export const formatTimeAgo = (items: Array<{ createdAt: string; timeAgo?: string }>) => {
    if (!items || !Array.isArray(items)) return;

    items.forEach(item => {
        item.timeAgo = dayjs(item.createdAt).fromNow();
    });
};
